module.exports = __webpack_public_path__ + "img/honor.8287ea50.png";